import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController, App } from 'ionic-angular';
import { Chart } from "chart.js";
import { DashboardPage } from '../dashboard/dashboard';
import { WelcomePage } from '../../welcome/welcome';
import { Storage } from '@ionic/storage'


@IonicPage({ name: "main", segment: "app" })
@Component({
  selector: 'page-lunchemployer',
  templateUrl: 'lunchroulette-employer.html',
})
export class LunchrouletteEmployerPage {
  @ViewChild("lineCanvas") lineCanvas: ElementRef;
  private lineChart: Chart;

  @ViewChild("satisfactionCanvas") satisfactionCanvas: ElementRef;
  private satisfactionChart: Chart;


  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController,
    public storageProvider: Storage,
    public app: App) {
    menu.enable(true);
  }

  ionViewDidLoad() {

  }


  ngOnInit() {
    this.lineChart = new Chart(this.lineCanvas.nativeElement, {
      type: "bar",
      data: {
        labels: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
        datasets: [
          {
            label: "évènement(s)",
            fill: false,
            lineTension: 0.1,
            borderColor: "rgba(17,139, 216, 0.4)",
            borderCapStyle: "butt",
            borderDash: [],
            backgroundColor: ["#DBEAF1", "#AED3E5", "#2787B7", "#035D8F", "#024669", "#024669", "#AED3E5"],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(17,139, 216, 0.4)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(17,139, 216, 0.4)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [1, 4, 1, 4, 6, 0, 0],
            spanGaps: false
          }
        ]
      },
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          displayColors: false,
          enabled: false,
        },
        tooltipTemplate: "<%= value %>",
        onAnimationComplete: function () {
          this.showTooltip(this.datasets[0].bars);
        },

        tooltipEvents: [],

        showAllTooltips: true,
        responsive: true,
      }
    });



    this.satisfactionChart = new Chart(this.satisfactionCanvas.nativeElement, {
      type: "line",
      data: {
        labels: ["Jan 20", "Fev 20", "Mar 20", "Avr 20", "Mai 20", "Jui 20", "Juil 20"],
        datasets: [
          {
            label: "Satisfaction (%)",
            fill: true,
            lineTension: 0.1,
            borderColor: "rgba(17,139, 216, 0.4)",
            borderCapStyle: "butt",
            borderDash: [],
            backgroundColor: ["#DBEAF1", "#AED3E5", "#2787B7", "#035D8F", "#024669", "#024669", "#AED3E5"],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(17,139, 216, 0.4)",
            pointBackgroundColor: "rgba(17,139, 216, 0.4)",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(17,139, 216, 0.4)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [78, 85, 74, 76, 89, 98, 82],
            spanGaps: false
          }
        ]
      },
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          displayColors: false,
          enabled: false,
        },
        tooltipTemplate: "<%= value %>",
        onAnimationComplete: function () {
          this.showTooltip(this.datasets[0].bars);
        },

        tooltipEvents: [],

        showAllTooltips: true,
        responsive: true,
      }
    });
  }

  logout(){
    this.storageProvider.remove('access_token').then(() => console.log('logout'))
    this.app.getRootNav().setRoot(WelcomePage)
    .then(() => {
      
    })
  }

}





// WEBPACK FOOTER //
// ./src/pages/employer/lunchroulette/lunchroulette.ts